//userAgent
var ua = navigator.userAgent;
var breakpoint = window.matchMedia("(max-width: 767px)");
var $images = $('.js-image-switch');
var sp = '_sp.';
var pc = '_pc.';

//userAgent デバイス判定
var _ua = (function(u){
  return {
    isTablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    isMobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

//IE・Edge判定
var isEdge = false;
var userAgent = window.navigator.userAgent.toLowerCase();
if( userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/) ) {
  var isIE = true;
  var ieVersion = userAgent.match(/((msie|MSIE)\s|rv:)([\d\.]+)/)[3];
  ieVersion = parseInt(ieVersion);
} else {
  var isIE = false;
  if(userAgent.indexOf("edge" )!= -1){
    isEdge = true;
  }
}

(function($){
  $(function(){
    //スマホメニュー
    spmenu();

    //iOS リンクのダブルタップバグ
    if(/iPhone|iPad|iPod/.test(ua)) {
      $("body").addClass("_ios");
    }

    //PCのとき 電話番号 無効
    if(!_ua.isMobile){
      $(".-telink").on('click', function(){
        return false;
      });
    }

    //スムーズスクロール
    if(location.href.indexOf("file")==0){
      var url = "file://" + location.hostname + location.pathname + location.search;
    }else if(location.href.indexOf("https")==0){
      var url = "https://" + location.hostname + location.pathname + location.search;
    }else{
      var url = "http://" + location.hostname + location.pathname + location.search;
    }
    $("a[href*='#'],area[href*='#']").on('click', function() {
      var id = this.href.substring(this.href.indexOf('#'),this.href.length);
      var hrefUrl = this.href.split(id);
      if(String(hrefUrl[0]) == String(url)) {
        var hash = this.hash;
        if(!hash || hash == "#") {
          return false;
        }else if(id == '#inbox') {
          $('html, body').animate({scrollTop: 0}, 1000, "swing");
          return false;
        }else if(id != "#"){
          $('html, body').animate({scrollTop: $(hash).offset().top - $("#shopify-section-header").height()}, 1000, "swing");
          return false;
        }
      }
    });

    //アコーディオン
    $('.ac-body').hide();
	  $(".ac-head").on('click',function(){
      var $target = $(this);
	    $target.parents('.swiper-wrapper').addClass('-ac');
	    $target.toggleClass('-open').next('.ac-body').slideToggle(400);
    });

    // resize
    //$(window).on('resize', function () {
    //  // resize check exec
    //  if (resizeTimer !== false) {
    //    clearTimeout(resizeTimer);
    //  }
    //  resizeTimer = setTimeout(function() {
    //    checkWindowSize();
    //  }, 200);
    //});

    var topMainVisualSlider = new Swiper('.js-main-visual', {
      effect: 'fade',
      loop: true,
      speed: 3000,
      slidesPerView: 1,
      autoplay: {
        disableOnInteraction: false
      }
    });

    var topHotWordSlider = new Swiper('.js-hot-word-slider', {
      spaceBetween: 8,
      slidesPerView: 3.5,
      navigation: {
        prevEl: '.js-hot-word-prev',
        nextEl: '.js-hot-word-next'
      },
      breakpoints: {
        768: {
          spaceBetween: 16,
          slidesPerView: 2.5
        }
      }
    });

    var carouselswiper = new Swiper('.garally-carousel',{
      slidesPerView: '20',
      freeMode: false,
      watchSlidesProgress: true,
      spaceBetween: 5,
    });
    var productSlider = new Swiper('.garally-original',{
      slidesPerView: 1,
      loop: true,
      noSwiping: true,
      navigation:{
        prevEl: '.prev-arrow',
        nextEl: '.next-arrow',
      },
      thumbs: {
        swiper: carouselswiper
      },
    });

    var topRecommendSlider;
    var topRecommendSliderTrigger = function () {
      topRecommendSlider = new Swiper('.js-top-recommend', {
        slidesPerView: 1.1,
        spaceBetween: 10 
      });
    };

    var scroller = document.scrollingElement, resizeTimeout;

    function checkWindowSize() {
      var viewportWidth = scroller.clientWidth;
      scroller.style.setProperty('--window-width', viewportWidth + 'px');
      scroller.style.setProperty('--window-width-half', (viewportWidth / 2) + 'px');
    }

    requestAnimationFrame(checkWindowSize);

    $(window).on('resize', function () {
      if (resizeTimeout) {
        window.cancelAnimationFrame(checkWindowSize);
      }
      resizeTimeout = window.requestAnimationFrame(checkWindowSize);
    });

    $('.js-faq-list').find('dt:first-of-type').addClass('-open').next().show();
    $('.js-faq-list').find('dt').off('click').on('click', function () {
      $(this).toggleClass('-open').next().slideToggle();
    });

    // $('.js-concept-showcase').infiniteslide({
    //   pauseonhover: false,
    //   responsive: true,
    //   clone: 3
    // });

    function breakpointChecker() {
      if (breakpoint.matches) {
        $images.each(function () {
          $(this).attr('src', $(this).attr('src').replace(pc, sp));
        });
        topRecommendSliderTrigger();
      } else {
        $images.each(function () {
          $(this).attr('src', $(this).attr('src').replace(sp, pc));
        });
        if (topRecommendSlider !== undefined) topRecommendSlider.destroy(true, true);
      }
    }

    breakpointChecker();
    breakpoint.addEventListener('change', breakpointChecker);

    var clsSize = $('.garally-carousel').innerHeight() - 20;
    $('.product__media-wrapper .prev-arrow,.product__media-wrapper .next-arrow').css({'top':`calc(50% - ${clsSize}px)`});

  });


  // on Load event
  $(window).on('load', function(){
    //checkWindowSize();
  });


  //スマホメニュー
  var menuState = false;
  var menuPos;
  function spmenu() {
    var menu = $('#sp-nav'),
        menuBtn = $('#js-menuButton');

    // open
    menuBtn.on('click', function(){
      menu.stop().fadeToggle(300);
      $(this).toggleClass("-open");
      if(menuState == false) { // スクロールを無効
        menuPos = $(window).scrollTop();
        $('body').addClass('-fixed').css({'top': -menuPos});
        menuState = true;
      } else {
        $('body').removeClass('-fixed').css({'top': 0});
        window.scrollTo(0, menuPos );
        menuState = false;
      }
      if($('body').hasClass('-fixed')){
        $('.c-btn-cart').css('z-index','100');
      }else{
        $('.c-btn-cart').css('z-index','110');
      }
    });

    $(window).on('resize', function () {
      var windowW = $(window).width();
      if(menu.length && windowW>960 && menuState!=false){
        menu.hide();
        menuBtn.removeClass("-open");
        $('body').removeClass('-fixed').css({'top': 0});
        window.scrollTo(0,menuPos);
        menuState = false;
      }
    });
  }

  // resize check exec
  //var resizeTimer = false;
  //function checkWindowSize(){
  //  var windowW = $(window).width();
  //  if(windowW > 960 ){
  //    $("").each(function() {
  //      $(this).find("li").tile(3);
  //    });
  //  } else {
  //    $("").find("li").height("auto");
  //  }
  //}

  //カレンダー1
  $(function() {
    var calendarEl = document.getElementById('calendar');

    var calendar = new FullCalendar.Calendar(calendarEl, {
      headerToolbar: {
        left: '',
        center: 'title',
        right: ''
      },
      height: 260,
      locale: 'ja',
      displayEventTime: false,
      selectable: false,
      googleCalendarApiKey: 'AIzaSyDwHofHhC7jNLAwUn2cVA__jwJ_0Kh-pWM',
      eventSources:[
        {
          googleCalendarId: 'ja.japanese#holiday@group.v.calendar.google.com',
          display: 'background',
          color: '#c00',
          textColor: '#ebebeb'
        }
      ],
      loading: function(bool) {
        document.getElementById('loading').style.display =
        bool ? 'block' : 'none';
      },
      dayCellContent: function(e) {
        e.dayNumberText = e.dayNumberText.replace('日', '');
      },
    });
    calendar.render();
    //カレンダー2
    var calendarElN = document.getElementById('calendarNext');
    var dates = new Date();
    var y = dates.getFullYear();
    var m = ("00" + (dates.getMonth()+2)).slice(-2);
    var d = ("00" + (dates.getDate() - (dates.getDate() - 1))).slice(-2);
    var intial = y+m+d;

    var calender2 = new FullCalendar.Calendar(calendarElN, {
      headerToolbar: {
        left: '',
        center: 'title',
        right: ''
      },
      height: 260,
      initialDate: intial,
      locale: 'ja',
      displayEventTime: false,
      selectable: false,
      googleCalendarApiKey: 'AIzaSyDwHofHhC7jNLAwUn2cVA__jwJ_0Kh-pWM',
      eventSources:[
        {
          googleCalendarId: 'ja.japanese#holiday@group.v.calendar.google.com',
          display: 'background',
          color: '#c00',
          textColor: '#ebebeb'
        }
      ],
      loading: function(bool) {
        document.getElementById('loading2').style.display =
        bool ? 'block' : 'none';
      },
      dayCellContent: function(e) {
        e.dayNumberText = e.dayNumberText.replace('日', '');
      }
    });
    calender2.render();
    tdelete(500);
  });
  function tdelete(){
    $('.fc-event-title').hide();
  }

  setTimeout(function(){
    $('.globo-form-control >textarea').parents().addClass('textarea');
  },1000);

  function timedulatiuon(){
    var instaSwiper = new Swiper('.insta-list',{
      freeMode: true,
      centeredSlides:true,
      spaceBetween: 10,
      speed: 1000,
      slidesPerView: 6,
      loop: true,
      autoplay: {
        delay: 4000,
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 4,
        },
      }
    });
  }
  $.ajax({
    type: 'GET',
    url: 'https://graph.facebook.com/v14.0/17841454849544898?fields=name%2Cmedia.limit(16)%7Bcaption%2Clike_count%2Cthumbnail_url%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=EAAVpUskMLdMBAC56bJfIMb8qklR6Im8Cc5pfD0mMHcbhxq3rpVCzxTDNeP6tApe6ZAiH26WaUMswUQOqYPklKRdyVqUGkdbVqlZAHRyN2g1ijMZCfyWGPDIlW3j0lH9Qkhd4XZCpGpZCzum2PUtzhUohxxsRaEwBcDzapgXdoMFXdZC4QkzIbM',
    dataType: 'json',
    success: function(json) {
      var html = '';
      var insta = json.media.data;
      for (var i = 0; i < insta.length; i++) {
          var image;
          if (!insta[i].thumbnail_url) {
            // 動画の場合はこちら
            image = insta[i].media_url;
          } else {
            // 写真の場合はこちら
            image = insta[i].thumbnail_url;
          } 
          html += '<li class="swiper-slide"><a href="' + insta[i].permalink + '" target="_blank"><img src="' +  image  + '"></a></li>';
      }
      $(".insta-slider").append(html); 
      timedulatiuon(300);
    },
    error: function() {  }
  });
})(jQuery);